import { first } from 'lodash';

import packageInfo from '../../package.json';

const envName = first(Object.entries(packageInfo.environment).find(([, value]) => value));

export const currentEnvName: string = typeof envName === 'string' ? envName : 'dev';
